import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutComponent } from './views/layout/layout.component';
import { AllowUrlGuard } from './core/guards/allow-url.guard';
import { AllowUrlGuardChild } from './core/guards/allow-url.guard-child';
import { AuthSessionResolver } from './core/resolvers/auth-session.resolver';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard, AllowUrlGuard],
    canActivateChild: [AllowUrlGuardChild],
    resolve: { verified: AuthSessionResolver },
    data: { authRequest: { scopes: ['user.read'] } },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then(
            m => m.DashboardModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./views/settings/settings.module').then(
            m => m.SettingsModule
          ),
      },
      {
        path: 'promotions',
        loadChildren: () =>
          import('./views/promotions/promotions.module').then(
            m => m.PromotionsModule
          ),
      },
      {
        path: 'calculator',
        loadChildren: () =>
          import('./views/calculator/calculator.module').then(
            m => m.CalculatorModule
          ),
      },
      {
        path: 'releases',
        loadChildren: () =>
          import('./views/releases/releases.module').then(
            m => m.ReleasesModule
          ),
      },
      {
        path: 'technical-consulting',
        loadChildren: () =>
          import('./views/technical-consulting/technical-consulting.module').then(
            m => m.TechnicalConsultingModule
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./views/users/users.module').then(
            m => m.UsersModule
          ),
      },
      {
        path: 'polls',
        loadChildren: () =>
          import('./views/masive-polls/masive-polls.module').then(
            m => m.MasivePollsModule
          ),
      },
      {
        path: 'suggested-volumen',
        loadChildren: () =>
          import('./views/suggested-volumen/suggested-volumen.module').then(
            m => m.SuggestedVolumenModule
          ),
      },
      {
        path: 'pop-up',
        loadChildren: () =>
          import('./views/pop-up/pop-up.module').then(
            m => m.PopUpModule
          ),
      },
      {
        path: 'data-policy',
        loadChildren: () =>
          import('./views/data-policy/data-policy.module').then(
            m => m.DataPolicyModule
          ),
      },
      {
        path: 'suggested-product',
        loadChildren: () =>
          import('./views/suggested-product/suggested-product.module').then(
            m => m.SuggestedProductModule
          ),
      },
      {
        path: 'users-masive',
        loadChildren: () =>
          import('./views/users-masive/users-masive.module').then(
            m => m.UsersMasiveModule
          ),
      },
      {
        path: 'mba',
        loadChildren: () =>
          import('./views/mba/mba.module').then(
            m => m.MbaModule
          ),
      },
      {
        path: 'role',
        loadChildren: () =>
          import('./views/role/role.module').then(
            m => m.RoleModule
          ),
      },
      {
        path: 'routines-form',
        loadChildren: () =>
          import('./views/routines-form/routines-form.module').then(
            m => m.RoutinesFormModule
          ),
      },
      {
        path: 'report/synchronization-report',
        loadChildren: () =>
          import('./views/reports/user-nitro-report/user-nitro-report.module').then(
            m => m.UserNitroReportModule
          ),
      },
      {
        path: 'users-bo',
        loadChildren: () =>
          import('./views/users-bo/users-bo.module').then(
            m => m.UsersBoModule
          ),
      },
      {
        path: 'parameters',
        loadChildren: () =>
          import('./views/parameters/parameters.module').then(
            m => m.ParametersModule
          ),
      },
      {
        path: 'menus',
        loadChildren: () =>
          import('./views/menus/menus.module').then(
            m => m.MenusModule
          ),
      },
    ],
  },
  {
    path: 'unauthorized',
    loadChildren: () =>
      import('./views/unauthorized/unauthorized.module').then(
        m => m.UnauthorizedModule
      ),
  },
    {
    path: 'user-not-active',
    loadChildren: () =>
      import('./views/user-not-active/user-not-active.module').then(
        m => m.UserNotActiveModule
      ),
  },
  {
    path: 'not-user-found',
    loadChildren: () =>
      import('./views/not-found-user/not-found-user.module').then(
        m => m.NotFoundUserModule
      ),
  },
  {
    path: 'code',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'error',
    redirectTo: 'unauthorized',
  },
  {
    path: '**',
    loadChildren: () =>
    import('./views/not-found/not-found.module').then(
      m => m.NotFoundModule
    ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
